import { useState } from 'react';
import { ModuleTypeClient, ModuleTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useModuleTypeApi = () => {
    const apiClient = new ModuleTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ModuleTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createModuleType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ModuleType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ModuleTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateModuleType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ModuleType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getModuleTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ModuleType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchModuleTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ModuleTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteModuleType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ModuleType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};